export enum StepLbpaType {
    SIGNATURE_PARCOURS_LBPA = 'signature_parcours_lbpa'
}



// WEBPACK FOOTER //
// ./src/app/enum/step-lbpa-type.enum.ts